import { render } from "./Record.vue?vue&type=template&id=47065cf2&scoped=true&ts=true"
import script from "./Record.vue?vue&type=script&lang=ts"
export * from "./Record.vue?vue&type=script&lang=ts"

import "./Record.vue?vue&type=style&index=0&id=47065cf2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47065cf2"]])

export default __exports__